// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1EOzc","title":"Header_title__1BMTU","left":"Header_left__3iflz","clinicName":"Header_clinicName__OzAOd"};